import React, { useEffect, useState } from "react";
import { Button, List, Loader } from "semantic-ui-react";

import { useLoadCustomTheme } from "../../api/api.hooks";
import { apiCustomThemeDtl, apiCustomThemeUserGroup, apiLoadCustomTheme } from "../../types";

type CustomThemeUserReportsProps = {
  reports: apiCustomThemeUserGroup["reports"];
  // 取得済みのレポート詳細。トグルの開閉や再描画で再取得しないために、呼び出し元で保持する（キー: user.id）
  cache: Map<number, apiCustomThemeDtl[]>;
  userId: number;
  useDivided?: boolean;
  renderItem: (item: apiCustomThemeDtl) => JSX.Element;
};

// ユーザー単位のトグルを開いた時に、そのユーザーのレポート詳細だけを取得して表示する
export const CustomThemeUserReports = (props: CustomThemeUserReportsProps) => {
  const { callLoadCustomTheme } = useLoadCustomTheme();
  const [items, setItems] = useState<apiCustomThemeDtl[] | undefined>(props.cache.get(props.userId));
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFailed, setIsFailed] = useState<boolean>(false);

  const load = async () => {
    setIsLoading(true);
    setIsFailed(false);
    const { isSuccess, result } = await callLoadCustomTheme(props.reports);
    if (isSuccess) {
      const customThemes = (result as apiLoadCustomTheme).customThemes;
      props.cache.set(props.userId, customThemes);
      setItems(customThemes);
    } else {
      // エラーメッセージは API フック側のエラーバナーで表示される
      setIsFailed(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (items === undefined) {
      load();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (items !== undefined) {
    return (
      <List divided={props.useDivided}>
        {items.map((item) => (
          <List.Item key={`${item.report.accountOriginalFlg}-${item.report.id}`}>{props.renderItem(item)}</List.Item>
        ))}
      </List>
    );
  }
  if (isFailed) {
    return <Button content="再読み込み" size="mini" icon="refresh" onClick={load} />;
  }
  return (
    <Loader active={isLoading} inline="centered" size="small">
      読み込み中...
    </Loader>
  );
};
